import {useEffect, useState} from "react";
import CustomLoader from "../../../../util/component/CustomLoader";

export default function Loading(props: any) {
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        window.addEventListener("LOADING", eventHandler);
    }, []);

    const eventHandler = (e: any) => {
        setLoading(e.detail);
    };

    return (
        <CustomLoader loading={loading}/>
    );
}
